import * as React from "react";
import { useEffect } from "react";
import { FeatureTermly } from "../app/consts";
import { useConfig } from "./config/ConfigContext";

const termly = function () {
  // console.log("Termly Init");
  const termlyId = "194874d7-97f2-4620-b410-641b8042b801";

  try {
    const termlyStorage = localStorage.getItem("TERMLY_API_CACHE");
    if (termlyStorage != null) {
      const termlyCache = JSON.parse(termlyStorage);

      if (termlyCache !== null && !termlyCache.hasOwnProperty(`__tltpl_${termlyId}`)) {
        localStorage.removeItem("TERMLY_API_CACHE");
      }
    }
  } catch (ex) {
    console.log(ex);
  }

  // (function (doc, url) {
  //   if (!doc.querySelector('script[src*="' + url + '"]')) {
  //     let script = doc.createElement("script");
  //     script.type = "text/javascript";
  //     // script.async = true;
  //     script.src = url;
  //     // script.id = termlyId;
  //     let x = document.getElementsByTagName("script")[0];
  //     x.parentNode!.insertBefore(script, x);
  //   }
  // })(document, `https://app.termly.io/resource-blocker/${termlyId}?autoBlock=on`);
};

export const Termly = () => {
  const { isFeatureEnabled } = useConfig();

  useEffect(() => {
    if (isFeatureEnabled(FeatureTermly)) {
      termly();
    }
  }, [isFeatureEnabled]);
  return <React.Fragment />;
};

export const getConsentForCategory = (category: string) => {
  const termlyCacheString = localStorage.getItem("TERMLY_API_CACHE");

  if (!termlyCacheString) {
    return false;
  }

  try {
    const termlyCache = JSON.parse(termlyCacheString);
    const consentInfo = termlyCache["TERMLY_COOKIE_CONSENT"]?.value;
    if (!consentInfo) {
      return false;
    }
    switch (category) {
      case "analytics":
        return consentInfo.analytics === true;
      case "advertising":
        return consentInfo.advertising === true;
      case "essential":
        return consentInfo.essential === true;
      case "performance":
        return consentInfo.performance === true;
      case "social_networking":
        return consentInfo.social_networking === true;
    }
  } catch (e) {
    console.error("Error parsing Termly API Cache:", e);
    return false;
  }

  return false;
};
